import { MarkerClusterer } from '@react-google-maps/api'
import { useCallback, useState, FC } from 'react'
import { CemeteryMarker } from './CemeteryMarker'
import { useListMapItems } from './dependencies'

type CemeteryMarkerClustererProps = {
  ids: number[]
}

export const CemeteryMarkerClusterer: FC<CemeteryMarkerClustererProps> = ({
  ids
}) => {
  const groupedItem = useListMapItems(ids)

  const [infoWindowId, setInfoWindowId] = useState<string | null>(null)
  const closeInfoWindow = useCallback(() => setInfoWindowId(null), [])

  return (
    <MarkerClusterer averageCenter>
      {(clusterer) => {
        return (
          <>
            {groupedItem.map(([key, items]) => {
              const item = items[0]
              if (!item) return null
              return (
                <CemeteryMarker
                  items={items}
                  closeInfoWindow={closeInfoWindow}
                  openInfoWindow={() => setInfoWindowId(key)}
                  clusterer={clusterer}
                  position={item.location}
                  showInfoWindow={infoWindowId === key}
                  key={key}
                />
              )
            })}
          </>
        )
      }}
    </MarkerClusterer>
  )
}
